import { DEFAULT_TIME_ZONE } from '@shared/lib/datetime/time-zone'
import type { TenantBrandingResponse } from '../types/branding.types'

export const defaultBranding: TenantBrandingResponse = {
  tenantUuid: '',
  name: 'Verbum',
  domain: null,
  timezone: DEFAULT_TIME_ZONE,
  branding: {
    displayName: 'Verbum',
    storageRootDirectory: 'verbum',
    logoUrl: null,
    light: {
      background: '45 33% 98%',
      foreground: '222 31% 15%',
      card: '0 0% 100%',
      cardForeground: '222 31% 15%',
      popover: '0 0% 100%',
      popoverForeground: '222 31% 15%',
      primary: '193 92% 30%',
      primaryForeground: '210 40% 98%',
      secondary: '43 35% 94%',
      secondaryForeground: '222 31% 15%',
      muted: '40 27% 93%',
      mutedForeground: '217 14% 42%',
      accent: '190 43% 94%',
      accentForeground: '222 31% 15%',
      destructive: '0 72% 46%',
      destructiveForeground: '210 40% 98%',
      border: '200 19% 86%',
      input: '200 19% 86%',
      ring: '193 92% 30%',
    },
    dark: {
      background: '218 29% 10%',
      foreground: '210 40% 98%',
      card: '218 26% 13%',
      cardForeground: '210 40% 98%',
      popover: '218 26% 13%',
      popoverForeground: '210 40% 98%',
      primary: '190 86% 64%',
      primaryForeground: '218 29% 10%',
      secondary: '218 18% 18%',
      secondaryForeground: '210 40% 98%',
      muted: '218 18% 18%',
      mutedForeground: '214 16% 70%',
      accent: '218 18% 16%',
      accentForeground: '210 40% 98%',
      destructive: '0 68% 44%',
      destructiveForeground: '210 40% 98%',
      border: '217 18% 24%',
      input: '217 18% 24%',
      ring: '190 86% 64%',
    },
  },
}
